export default __webpack_public_path__ + "static/impact-150d98866331c9bf9401d3332b77824e.png";